<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="app-content--inner d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="bg-composed-wrapper--content py-5 text-center">
              <img src="@/assets/not-found.png" alt="Not Found" width="500">
              <h3 class="pt-4">Data tidak ditemukan</h3>
              <p class="pt-2 fs-12">Maaf, Data yang Anda cari tidak ditemukan.</p>
              <b-button @click="redirect" class="btn-back">Kembali ke Dashboard</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    redirect() {
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="scss">
.modal-verification {
  max-width: 580px;
}

.btn-back {
  color: #fff;
  background-color: #3c44b1;
  border-color: #3c44b1;
}

.btn-back:hover {
  opacity: 0.9;
  color: #fff !important;
  background-color: #3c44b1 !important;
  border-color: #3c44b1 !important;
}
</style>
